
// document.addEventListener("DOMContentLoaded", function () {
//   const swiperContainers = document.querySelectorAll(
//     ".swiper-container.cstm-swiper"
//   );

//   swiperContainers.forEach((container) => {
//     const swiper = new Swiper(container, {
//       loop: true,
//       effect: "fade",
//       speed: 2000,
//       navigation: {
//         nextEl: container.querySelector(".swiper-button-next"),
//         prevEl: container.querySelector(".swiper-button-prev"),
//       },
//       on: {
//         init: function () {
//           const activeSlide = container.querySelector(".swiper-slide-active");
//           playVideo(activeSlide);
//         },
//         slideChangeTransitionStart: function () {
//           container.querySelectorAll("video").forEach((video) => {
//             video.pause();
//             video.currentTime = 0; // Reset to the beginning
//           });
//         },
//         slideChangeTransitionEnd: function () {
//           const activeSlide = container.querySelector(".swiper-slide-active");
//           playVideo(activeSlide);
//         },
//       },
//     });

//     function playVideo(slide) {
//       const isMobile = window.innerWidth <= 768;
//       const videoSelector = isMobile ? ".mobile-video" : ".desktop-video";
//       const video = slide.querySelector(videoSelector);

//       if (video) {
//         video.play().catch((error) => {
//           console.error("Error playing video:", error);
//         });
//       }
//     }
//   });
// });
//document.addEventListener("DOMContentLoaded", function () {
  const swiperContainers = document.querySelectorAll(".swiper-container.cstm-swiper");

  swiperContainers.forEach((container) => {
    const swiperWrapper = container.querySelector(".swiper-wrapper");
    
    // Get autoplay and slide change time from attributes
    const autoplay = swiperWrapper.getAttribute("data-autoplay") === "true";
    const slideChangeTime = parseInt(swiperWrapper.getAttribute("data-slidechange-time")) || 2000;

    const swiper = new Swiper(container, {
      loop: true,
      effect: "fade",
      speed: slideChangeTime, // Use dynamic speed
      autoplay: autoplay ? { delay: slideChangeTime, disableOnInteraction: false } : false,
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      on: {
        init: function () {
          const activeSlide = container.querySelector(".swiper-slide-active");
          playVideo(activeSlide);
        },
        slideChangeTransitionStart: function () {
          container.querySelectorAll("video").forEach((video) => {
            video.pause();
            video.currentTime = 0; // Reset to the beginning
          });
        },
        slideChangeTransitionEnd: function () {
          const activeSlide = container.querySelector(".swiper-slide-active");
          playVideo(activeSlide);
        },
      },
    });

    function playVideo(slide) {
      const isMobile = window.innerWidth <= 768;
      const videoSelector = isMobile ? ".mobile-video" : ".desktop-video";
      const video = slide.querySelector(videoSelector);

      if (video) {
        video.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      }
    }
  });
//});
